<mat-list interactive="false">
  <mat-list-item>
    <sn-icon mat-list-icon>{{ share.object.icon }}</sn-icon>
    <div mat-line>{{ share.object.name }}</div>
    <div mat-line class="shareDetailsComp">{{ 'common.object' | t }}</div>
  </mat-list-item>
  <mat-list-item *ngIf="share.isOut">
    <sn-icon mat-list-icon>share</sn-icon>
    <div mat-line>{{ share.sharerOrganization.name }}</div>
    <div mat-line class="shareDetailsComp">{{ 'shares.sharedWith' | t }}</div>
  </mat-list-item>
  <mat-list-item *ngIf="share.isIn">
    <sn-icon mat-list-icon>share</sn-icon>
    <div mat-line>{{ share.ownerOrganization.name }}</div>
    <div mat-line>{{ 'common.owner' | t }}</div>
  </mat-list-item>
</mat-list>
